export default function reducer(state = {
    processed: false,
    errors: {},
}, action) {
    switch (action.type) {
        case 'PATCH_WELCOME_PENDING': {
            return {...state, processed: false}
        }
        case 'PATCH_WELCOME_FULFILLED': {
            return {
                ...state,
                processed: true,
            }
        }
        case 'PATCH_WELCOME_REJECTED': {
            return {
                ...state, errors: action.payLoad
            }
        }
        default:
    }

    return {...state};
}


// WEBPACK FOOTER //
// ./src/reducers/welcomeReducer.js